// This is a skeleton starter React component generated by Plasmic.
// Feel free to edit as you see fit.
import { AppCtx } from "@/wab/client/app-ctx";
import HostUrlInput from "@/wab/client/components/HostUrlInput";
import { Modal } from "@/wab/client/components/widgets/Modal";
import React from "react";

interface HostConfigProps {
  appCtx: AppCtx;
  onCancel: () => void;
  onUpdate: () => void;
}

export function AddTrustedHostModal({
  appCtx,
  onCancel,
  onUpdate,
}: HostConfigProps) {
  return (
    <Modal
      title={"Add trusted host"}
      visible
      onCancel={() => onCancel()}
      footer={null}
    >
      Plasmic projects can be hosted by your own app! <br />
      It allows you to bring your own components to Plasmic. Learn more about
      Plasmic app-hosting and how to setup your app{" "}
      <a href="https://www.plasmic.app/learn/app-hosting/" target="_blank">
        here
      </a>
      .
      <HostUrlInput
        className="mv-xlg"
        originOnly
        onConfirm={async (_url, parsedUrl) => {
          await appCtx.api.addTrustedHost(parsedUrl.origin);
          onUpdate();
        }}
      />
      Remember to only add domains you trust.
    </Modal>
  );
}
